<template>
  <div class="wrap">
    <img src="../../../assets/img/not-goods.png" alt="">
    <p>抱歉，暂无相关商品</p>
    <p>去首页逛逛吧</p>
    <div class="btn" @click="$router.push('/home')">去首页</div>
  </div>
</template>

<script>
export default {
  name: 'not-goods'
}
</script>

<style scoped lang="scss">
.wrap{
  margin: auto;
  margin-top: 50px;
  width: 305px;
  height: 240px;
  background:rgba(255,255,255,1);
  border-radius:10px;
  text-align: center;
  position: relative;
  img{
    display: inline-block;
    width: 154px;
    height: 111px;
    margin-top: 8px;
    margin-bottom: 10px;
  }
  p{
    font-size: 12px;
    color: #333333;
    margin-bottom: 10px;
  }
  .btn{
    width: 150px;
    height: 35px;
    margin: 0 auto;
    border-radius: 17px;
    font-size: 16px;
    color: #ffffff;
    @include center();
    background: var(--APP_theme_color);
  }
}
</style>
